// import Axios from "axios";
// import { APIURL } from "../utils/misc";
import { TRANSCTION_TYPES } from "./types";
import api from "src/utils/api";

const fetch_transactions_success = (payload) => ({
  type: TRANSCTION_TYPES.FETCH_TRANSACTIONS,
  payload,
});

export const fetch_transactions_async = () => async (dispatch) => {
  try {
    // const host = localStorage.getItem("HOST_ID");
    const res = await api.get(`transactions/host`);
    dispatch(fetch_transactions_success(res.data.data));
  } catch (error) {
    console.log("trnasactions", error.message);
  }
};
